import { render, staticRenderFns } from "./infoEstudiante.vue?vue&type=template&id=74d6b5f3&scoped=true"
import script from "./infoEstudiante.vue?vue&type=script&lang=js"
export * from "./infoEstudiante.vue?vue&type=script&lang=js"
import style0 from "./infoEstudiante.vue?vue&type=style&index=0&id=74d6b5f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d6b5f3",
  null
  
)

export default component.exports